module.exports = __webpack_public_path__ + "static/media/artist_01.c1e7d3fe.png";